import styles from './requiredField.module.scss';

const RequiredField = () => {
	return (
		<label className={styles.container}>*</label>
	)
}

export default RequiredField;
